import React, { useEffect, useContext } from "react";
import Toast, { showToast } from "../../components/Toast";
import CampaignStatusBadge from "../../components/CampaignStatusBadge";
import { getCampaignStatus, getTimezoneByInstance } from "../../utils";
import { config } from "../../config";
import useScript from "../../hooks/useScript";
import { CustomI18nextContext } from "../../contexts/CustomI18nextContext";
import "./style.scss";

const CampaignInfoLayout = ({ content }) => {
  const { siteCountry } = useContext(CustomI18nextContext);
  const timezone = getTimezoneByInstance(siteCountry);
  const campaignStatus = getCampaignStatus(
    content.acfCampaignDate,
    timezone.tz
  );
  const isCampaignLive = campaignStatus === "live";

  const wpFormId = content.content?.match("wpcf7-f(.*)-o");

  const disableSubmitButton = (isDisable = true) => {
    const submitButton = document.querySelector("input[type=submit]");
    submitButton.disabled = isDisable;
  };

  const preFillEmail = (email) => {
    const emailField = document.querySelector("input[type=email]");
    emailField.value = email;
  };

  const createErrorElement = (message) => {
    const elemError = document.createElement("p");
    elemError.className = "error";
    elemError.innerHTML = message;

    return elemError;
  };

  const customizeForm = (wpFormId, email) => {
    const formId = `form-campaign-${wpFormId}`;

    const wpContent = content.content.replace(
      /action="(.*?)"/,
      `action="https://wp-api.zipmex.com/wp-json/contact-form-7/v1/contact-forms/${wpFormId}/feedback" id="${formId}"`
    );

    const elemContent = document.getElementById("campaign__content");
    elemContent.innerHTML = wpContent;

    disableSubmitButton();

    if (email) {
      preFillEmail(email);
    }

    const campaignForm = document.getElementById(formId);

    campaignForm.addEventListener("submit", async (event) => {
      event.preventDefault();

      const grecaptcha = document.querySelector(".g-recaptcha-response")?.value;
      if (!grecaptcha || !isCampaignLive) {
        showToast("campaign", "error");
      } else {
        disableSubmitButton();

        fetch(event.target.action, {
          method: "POST",
          body: new FormData(event.target),
        })
          .then((resp) => {
            return resp.json();
          })
          .then((body) => {
            if (body.status === "mail_sent") {
              showToast("campaign", "success");
              campaignForm.reset();
            } else {
              body.invalid_fields.forEach(({ into, message }) => {
                const invalidField = document.querySelector(`${into}`);
                const existingError =
                  invalidField.getElementsByClassName("error");

                const elemError = createErrorElement(message);

                if (!existingError.length) {
                  invalidField.appendChild(elemError);
                } else {
                  invalidField.replaceChild(elemError, existingError[0]);
                }
              });
            }
          })
          .catch((error) => {
            console.error(error);
            showToast("campaign", "error");
          })
          .finally(() => {
            disableSubmitButton(false);
          });
      }
    });
  };

  const renderRecaptcha = () => {
    const verifyCallback = () => {
      disableSubmitButton(false);
    };

    const expiredCallback = () => {
      disableSubmitButton();
    };

    const onloadCallback = () => {
      window.grecaptcha.render("recaptcha-wrapper", {
        sitekey: config.reCaptcha_key,
        callback: verifyCallback,
        "expired-callback": expiredCallback,
      });
    };

    window.onloadCallback = onloadCallback;

    const reCaptchaWrapper = document.createElement("div");
    reCaptchaWrapper.setAttribute("id", "recaptcha-wrapper");

    const submitButton = document.querySelector("input[type=submit]");
    submitButton.before(reCaptchaWrapper);
  };

  useEffect(() => {
    const search = new URLSearchParams(window.location.search);
    const email = search.get("email");

    if (wpFormId) {
      customizeForm(wpFormId[1], email);
      renderRecaptcha();
    } else {
      document.getElementById("campaign__content").innerHTML = content.content;
    }
  }, []);

  useScript(
    "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit",
    isCampaignLive && wpFormId
  );

  return (
    <div className="campaign pt-5 post">
      <Toast
        containerId="campaign"
        toastStatus="success"
        header="Thank you!"
        description="Your form submission has been received."
      />

      <Toast
        containerId="campaign"
        toastStatus="error"
        header="Something went wrong"
        description="Please try again later."
      />

      <div className="container page-content py-5">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <h1
              className="mb-3"
              dangerouslySetInnerHTML={{ __html: content.title }}
            />
            <div className="mb-5 d-inline-block d-md-flex">
              <p>
                {`${content.acfCampaignDate.campaignStartDate} - ${content.acfCampaignDate.campaignEndDate} (${timezone.offset})`}
              </p>
              <CampaignStatusBadge campaignStatus={campaignStatus} />
            </div>
            <div id="campaign__content" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignInfoLayout;
